<template>
  <main class="sustainability-index-page mx-auto py-8 overflow-x-hidden">
    <div class="max-w-screen-xl mx-auto px-4">
      <common-breadcrumb class="mb-8 xl:mt-8 xl:mb-16" :crumbs="breadCrumbs" />
    </div>
    <div
      v-if="sustainabilityPage?.headerCoverImage?.url"
      class="flex flex-col justify-center bg-depth-0 bg-cover! bg-center! min-h-[300px]"
      :style="{
        'background-image': `url(${sustainabilityPage.headerCoverImage.url})`,
      }"
    >
      <div class="max-w-screen-xl mx-auto px-4 h-fit max-md:p-8">
        <div class="text-left">
          <div class="w-full lg:w-2/3">
            <div class="xl:px-12">
              <h1 class="p-0 uppercase">{{ sustainabilityPage.headline }}</h1>
              {{ sustainabilityPage.headerText }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <section class="overflow-x-hidden">
      <strapi-sustainability-page-components
        v-if="sustainabilityPage?.content != null"
        :contents="sustainabilityPage.content"
      />
    </section>
  </main>
</template>

<script setup lang="ts">
import useSustainabilityPage from '~/components/sustainability/features/useSustainabilityPage';
import type { BreadCrumb } from '../common/types';
import { useGoogleBreadcrumb } from '~/helpers/googleBreadcrumb';
import { serializeJsonLd } from '~/helpers/jsonLd';

const { t, locale } = useI18n();
const config = useRuntimeConfig();
const route = useRoute();
const breadCrumbs = ref<Array<BreadCrumb>>([
  {
    title: t('general/menu/item/sustainability') as string,
    link: 'sustainability',
  },
]);

const googleBreadcrumb = computed(() =>
  useGoogleBreadcrumb(
    config.public.websiteUrl,
    locale.value,
    t('app/home'),
    breadCrumbs.value,
    route.path,
  ),
);

useHead({
  script: () => {
    const scripts = [];
    if (googleBreadcrumb.value) {
      scripts.push({
        type: 'application/ld+json',
        innerHTML: serializeJsonLd(googleBreadcrumb.value),
      });
    }
    return scripts;
  },
});

const { sustainabilityPage } = await useSustainabilityPage();
</script>
